import { Routes } from '@angular/router';

import { AutoLoginPartialRoutesGuard, autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

import { accountSetupGuard, signupCompletionGuard } from './core/guards/account-setup.guard';
import { NotFoundComponent } from './warn/not-found.component';
import { ForbiddenComponent } from './warn/forbidden.component';
import { UnauthorizedComponent } from './warn/unauthorized.component';
import { LoggedOutComponent } from './warn/logged-out.component';
import { CallbackComponent } from './callback/callback.component';

export const routes: Routes = [
    { path: 'terms', loadComponent: () => import('./home/support/terms-of-use/terms-of-use.component').then(c => c.TermsOfUseComponent) },
    { path: 'privacy', loadComponent: () => import('./home/support/privacy-statement/privacy-statement.component').then(c => c.PrivacyStatementComponent) },
    {
        path: 'login',
        loadComponent: () => import('./auth/auth-redirect.component').then(c => c.AuthRedirectComponent),
        canActivate: [AutoLoginPartialRoutesGuard]
    },
    {
        path: 'signup',
        loadComponent: () => import('./auth/auth-redirect.component').then(c => c.AuthRedirectComponent),
        canActivate: [AutoLoginPartialRoutesGuard],
        data: {
            action: 'signup',
            screen_hint: 'signup'
        }
    },
    {
        path: 'api/login',
        loadComponent: () => import('./auth/auth-redirect.component').then(c => c.AuthRedirectComponent),
        canActivate: [AutoLoginPartialRoutesGuard]
    },
    {
        path: 'api/signup',
        loadComponent: () => import('./auth/auth-redirect.component').then(c => c.AuthRedirectComponent),
        canActivate: [AutoLoginPartialRoutesGuard],
        data: {
            action: 'signup',
            screen_hint: 'signup'
        }
    },
    { path: 'callback', component: CallbackComponent },
    {
        path: 'docs',
        loadComponent: () => import('./public-documentation/public-documentation-shell.component').then(c => c.PublicDocumentationShellComponent),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'getting-started'
            },
            {
                path: 'getting-started',
                loadComponent: () => import('./public-documentation/public-documentation-getting-started.component').then(c => c.PublicDocumentationGettingStartedComponent)
            },
            {
                path: 'core-concepts',
                loadComponent: () => import('./public-documentation/public-documentation-core-concepts.component').then(c => c.PublicDocumentationCoreConceptsComponent)
            },
            {
                path: 'which-table-do-i-need',
                loadComponent: () => import('./public-documentation/public-documentation-which-table.component').then(c => c.PublicDocumentationWhichTableComponent)
            },
            {
                path: 'workflow-recipes',
                loadComponent: () => import('./public-documentation/public-documentation-workflow-recipes.component').then(c => c.PublicDocumentationWorkflowRecipesComponent)
            },
            {
                path: 'data-tables-reference',
                loadComponent: () => import('./public-documentation/public-documentation-data-tables-reference.component').then(c => c.PublicDocumentationDataTablesReferenceComponent)
            },
            {
                path: 'error-reference',
                loadComponent: () => import('./public-documentation/public-documentation-error-reference.component').then(c => c.PublicDocumentationErrorReferenceComponent)
            },
            {
                path: 'authentication',
                loadComponent: () => import('./public-documentation/public-documentation-authentication.component').then(c => c.PublicDocumentationAuthenticationComponent)
            },
            {
                path: 'platform-reliability',
                loadComponent: () => import('./public-documentation/public-documentation-platform-reliability.component').then(c => c.PublicDocumentationPlatformReliabilityComponent)
            },
            {
                path: 'product-schema',
                loadComponent: () => import('./public-documentation/public-documentation-product.component').then(c => c.PublicDocumentationProductComponent)
            },
            {
                path: 'nsn-search',
                loadComponent: () => import('./public-documentation/public-documentation-nsn-search.component').then(c => c.PublicDocumentationNsnSearchComponent)
            },
            {
                path: 'part-lookup/part-number-cage',
                loadComponent: () => import('./public-documentation/public-documentation-part-lookup.component').then(c => c.PublicDocumentationPartLookupComponent)
            },
            {
                path: 'part-lookup/batch',
                loadComponent: () => import('./public-documentation/public-documentation-part-batch-lookup.component').then(c => c.PublicDocumentationPartBatchLookupComponent)
            },
            {
                path: 'part-lookup/cage-parts',
                loadComponent: () => import('./public-documentation/public-documentation-cage-parts.component').then(c => c.PublicDocumentationCagePartsComponent)
            },
            {
                path: ':key/:table',
                loadComponent: () => import('./public-documentation/public-documentation-endpoint.component').then(c => c.PublicDocumentationEndpointComponent)
            }
        ]
    },
    {
        path: 'complete-signup',
        loadComponent: () => import('./complete-signup/complete-signup.component').then(c => c.CompleteSignupComponent),
        canActivate: [autoLoginPartialRoutesGuard, signupCompletionGuard]
    },
    {
        path: 'warn',
        loadComponent: () => import('./warn/warn.component').then(c => c.WarnComponent),
        children: [
            { path: '404', component: NotFoundComponent },
            { path: 'forbidden', component: ForbiddenComponent },
            { path: 'unauthorized', component: UnauthorizedComponent },
            { path: 'logout', component: LoggedOutComponent }
        ]
    },
    {
        path: '', 
        loadChildren: () => import('./home/home.routes').then(m => m.routes),
        canActivate: [autoLoginPartialRoutesGuard, accountSetupGuard]
    },
    {
        path: 'print',
        loadChildren: () => import('./print/print.routes').then(m => m.routes),
        canActivate: [autoLoginPartialRoutesGuard, accountSetupGuard]
    },
    { path: '**', pathMatch: 'full', redirectTo: '/warn/404' }
];
